import { ListedPropertyRoomGetAssessmentDetail } from 'domain/entities/PropertyEntity';
import { useAppDispatch } from 'presentation/redux/hooks';
import { useLocation } from 'react-router-dom';
import { COMMON } from 'utilities/constants/COMMON';
import React, { useState } from 'react';
import { ImageComponent } from 'presentation/components/ImageComponent';
import { MasterSubCategoryData } from 'domain/entities/MasterEntity';
import { commonHelpers } from 'utilities/helpers';
import ImageModal from '../../CU-009-01/components/ImageModal';
import FallbackImg from 'assets/images/FallbackImg.svg';

interface props {
    detailAssessment?: ListedPropertyRoomGetAssessmentDetail;
    options: MasterSubCategoryData[];
}

const TAB1_1Component = ({ detailAssessment, options }: props) => {
    const dispatch = useAppDispatch();
    const [isOpen, setIsOpen] = useState(false);
    const [currentIndex, setCurrentIndex] = useState(0);
    const location = useLocation();
    const { name } = location.state;
    const renderOption = (value: string, data: MasterSubCategoryData | undefined) => {
        const option = data && data.result?.filter((item) => item.code == value).at(0);
        return (option && option.codeName) || COMMON.EMPTY;
    };
    const nextImage = () => {
        if (detailAssessment && detailAssessment.result.propertyImages) {
            setCurrentIndex((prevIndex) => (prevIndex + 1) % detailAssessment.result.propertyImages.length);
        }
    };
    const prevImage = () => {
        if (detailAssessment && detailAssessment.result.propertyImages) {
            setCurrentIndex((prevIndex) => (prevIndex - 1 + detailAssessment.result.propertyImages.length) % detailAssessment.result.propertyImages.length);
        }
    };
    const RoomInfo = (props: {
        isBorderBottom?: boolean;
        gap?: number;
        marginRight?: number;
        label: string;
        value: any;
        detailAssessment: any;
        width?: any;
    }) => {
        return (
            <section
                className={`pd-element ${
                    props.isBorderBottom === undefined || props.isBorderBottom === true
                        ? 'border-bottom-des'
                        : ''
                }`}
                style={{
                    marginRight: props.marginRight ?? 48,
                    width: props.width ?? '100%',
                    minHeight: 50,
                    height: 'fit-content',
                }}
            >
                <div className="label" style={{ marginRight: props.gap ?? 8, minWidth: 300 }}>
                    {props.label}
                </div>
                <div className="value" style={{ flexGrow: 100 }}>
                    {props.value}
                    {props.detailAssessment?.result?.floorPlanUrl && (
                        <button className="floor-plan-btn" onClick={() => setIsOpen(true)}>
                            間取り図
                        </button>
                        )}
                </div>
            </section>
        );
    };
    
    const Info = (props: {
        isBorderBottom?: boolean;
        gap?: number;
        marginRight?: number;
        label: string;
        value: any;
        width?: any;
    }) => {
        return (
            <section
                className={`pd-element ${
                    props.isBorderBottom === undefined || props.isBorderBottom === true
                        ? 'border-bottom-des'
                        : ''
                }`}
                style={{
                    marginRight: props.marginRight ?? 48,
                    width: props.width ?? '100%',
                    minHeight: 50,
                    height: 'fit-content',
                }}
            >
                <div className="label" style={{ marginRight: props.gap ?? 8, minWidth: 300 }}>
                    {props.label}
                </div>
                <div className="value" style={{ flexGrow: 100 }}>
                    {props.value}
                </div>
            </section>
            
        );
    };

    return (
        <div
            style={{
                width: '100%',
                height: '100%',
                display: 'flex',
                flexFlow: 'column',
                paddingLeft: 20,
            }}
        >
            <section
                style={{
                    height: '100%',
                    width: '100%',
                    overflow: 'auto',
                    flexGrow: 1,
                    display: 'flex',
                    justifyContent: 'center',
                }}
            >
                <div className="main-container">
                    {detailAssessment?.result?.propertyImages.length === 0 || !detailAssessment?.result?.propertyImages ? (
                        <ImageComponent
                                parentClassName="h-164 full-width"
                                className="image-inside min-h-[335px]"
                                src={FallbackImg}
                                style={{ justifyContent: "center", objectFit: "contain", height: "300px"}}
                            />
                        ) : (
                            <div style={{ position: 'relative', width: '100%', overflow: 'hidden' }}>
                                <button
                                    style={{
                                        position: 'absolute',
                                        top: '50%',
                                        left: '10px',
                                        justifyContent: 'center',
                                        transform: 'translateY(-50%)',
                                        zIndex: 1,
                                    }}
                                    onClick={prevImage}
                                >
                                    {'<'}
                                </button>
                                <div
                                    style={{
                                        display: 'flex',
                                        transition: 'transform 0.5s ease-in-out',
                                        transform: `translateX(-${currentIndex * 100}%)`,
                                        width: `100%`,
                                    }}
                                >
                                    {detailAssessment?.result?.propertyImages.map((image: any, index: number) => (
                                        <div
                                            key={index}
                                            style={{
                                                minWidth: '100%',
                                                boxSizing: 'border-box',
                                            }}
                                        >
                                            <ImageComponent
                                                parentClassName="h-164 full-width"
                                                className="image-inside min-h-[335px]"
                                                src={image.imageFilePath.length > 0 ? image.imageFilePath : FallbackImg}
                                                style={{ justifyContent: "center", objectFit: "contain", height: "300px"}}
                                            />
                                        </div>
                                    ))}
                                </div>
                                <button
                                    style={{
                                        position: 'absolute',
                                        top: '50%',
                                        right: '10px',
                                        transform: 'translateY(-50%)',
                                    }}
                                    onClick={nextImage}
                                >
                                    {'>'}
                                </button>
                            </div>
                        )}
                    <div style={{ textAlign: 'left', fontWeight: 700, fontSize: 16 }}>
                        査定依頼内容
                    </div>
                    <Info label="物件名" value={name || COMMON.EMPTY} marginRight={0} />
                    <RoomInfo
                        label="部屋番号"
                        value={
                            detailAssessment?.result?.roomNumber
                                ? `${detailAssessment.result?.roomNumber}号室`
                                : COMMON.EMPTY
                        }
                        detailAssessment={detailAssessment}
                        marginRight={0}
                    />
                    <Info
                        label="専有部分所在階"
                        value={
                            detailAssessment?.result?.occupiedFloor
                                ? `${detailAssessment.result?.occupiedFloor}階`
                                : COMMON.EMPTY
                        }
                        marginRight={0}
                    />
                    <Info
                        label="専有面積"
                        value={
                            detailAssessment?.result?.occupiedArea
                                ? `${Number(detailAssessment.result?.occupiedArea)}m²`
                                : COMMON.EMPTY
                        }
                        marginRight={0}
                    />
                    <Info
                        label="バルコニー面積（任意）"
                        value={
                            detailAssessment?.result?.balconyArea
                                ? `${Number(detailAssessment.result?.balconyArea)}m²`
                                : COMMON.EMPTY
                        }
                        marginRight={0}
                    />
                    <Info
                        label="間取り"
                        value={
                            detailAssessment?.result?.roomLayoutDiv
                                ? `${renderOption(detailAssessment.result?.roomLayoutDiv, options.at(3))}`
                                : COMMON.EMPTY
                        }
                        marginRight={0}
                    />
                    <Info
                        label="バス・トイレ"
                        value={
                            detailAssessment?.result?.bathToiletSeparatedDiv
                                ? `${renderOption(detailAssessment.result?.bathToiletSeparatedDiv, options.at(0))}`
                                : COMMON.EMPTY
                        }
                        marginRight={0}
                    />
                    <Info
                        label="室内洗濯機置き場"
                        value={
                            detailAssessment?.result?.indoorLaundryRoomDiv
                                ? `${renderOption(detailAssessment.result?.indoorLaundryRoomDiv, options.at(1))}`
                                : COMMON.EMPTY
                        }
                        marginRight={0}
                    />
                    <Info
                        label="備考（任意）"
                        value={
                            detailAssessment?.result?.notes
                                ? `${detailAssessment.result?.notes}`
                                : COMMON.EMPTY
                        }
                        marginRight={0}
                    />
                    <Info
                        label="家賃"
                        value={
                            detailAssessment?.result?.rent
                                ? `${commonHelpers.formatNumberMoney(detailAssessment.result?.rent)}円`
                                : COMMON.EMPTY
                        }
                        marginRight={0}
                    />
                    <Info
                        label="共益費"
                        value={
                            detailAssessment?.result?.commonServiceFee
                                ? `${commonHelpers.formatNumberMoney(detailAssessment.result?.commonServiceFee)}円`
                                : COMMON.EMPTY
                        }
                        marginRight={0}
                    />
                    <Info
                        label="現在の状況"
                        value={
                            detailAssessment?.result?.presentCondDiv
                                ? `${renderOption(detailAssessment.result?.presentCondDiv, options.at(2))}`
                                : COMMON.EMPTY
                        }
                        marginRight={0}
                    />
                    <Info
                        label="管理費"
                        value={
                            detailAssessment?.result?.managementFee
                                ? `${commonHelpers.formatNumberMoney(detailAssessment.result?.managementFee)}円`
                                : COMMON.EMPTY
                        }
                        marginRight={0}
                    />
                    <Info
                        label="修繕積立金"
                        value={
                            detailAssessment?.result?.renovationDeposit
                                ? `${commonHelpers.formatNumberMoney(detailAssessment.result?.renovationDeposit)}円`
                                : COMMON.EMPTY
                        }
                        marginRight={0}
                    />
                    <Info
                        label="その他費用（インターネット使用料など）（任意）"
                        value={
                            detailAssessment?.result?.otherExpenses ||
                            detailAssessment?.result?.otherExpenses === 0
                                ? `${commonHelpers.formatNumberMoney(detailAssessment.result?.otherExpenses)}円`
                                : COMMON.EMPTY
                        }
                        marginRight={0}
                    />
                    <Info
                        label="その他費用備考"
                        value={
                            detailAssessment?.result?.otherExpensesNotes
                                ? `${detailAssessment.result?.otherExpensesNotes}`
                                : COMMON.EMPTY
                        }
                        marginRight={0}
                    />
                    <Info
                        label="残債"
                        value={
                            detailAssessment?.result?.loanBalance ||
                            detailAssessment?.result?.loanBalance === 0
                                ? `${commonHelpers.formatNumberMoney(Number(detailAssessment.result?.loanBalance))}円`
                                : COMMON.EMPTY
                        }
                        marginRight={0}
                    />
                    <Info
                        label="所有年数"
                        value={
                            detailAssessment?.result?.ownshipYear ||
                            detailAssessment?.result?.ownshipYear === 0
                                ? `${detailAssessment.result?.ownshipYear}年`
                                : COMMON.EMPTY
                        }
                        marginRight={0}
                    />
                </div>
            </section>
            {isOpen && (
            <ImageModal
              src={detailAssessment?.result.floorPlanUrl || ''}
              alt="間取り図"
              onClose={() => setIsOpen(false)}
            />
          )}
        </div>
    );
};

export default TAB1_1Component;
